import type { SVGProps } from "react";

export function IconWhiteBankNote(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M32 48C27.0294 48 23 52.0294 23 57M23 7C23 11.9706 27.0294 16 32 16M16 57C16 52.0294 11.9706 48 7 48M7 16C11.9706 16 16 11.9706 16 7M7 7H32V57H7V7ZM32 32C32 35.866 26.4036 39 19.5 39C12.5964 39 7 35.866 7 32C7 28.134 12.5964 25 19.5 25C26.4036 25 32 28.134 32 32Z"
        stroke="#23232C"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.25 15.75V14.25H53.0329L47.8236 30.25H60.0332L51.0797 57.75H49.5022L57.9673 31.75H47.3353L38.8701 57.75H37.2926L50.9671 15.75H34.25Z"
        fill="#23232C"
      />
    </svg>
  );
}
